var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoNotificationModal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_notification_modal",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_564",
    "data-name": "Trac\\xE9 564",
    d: "M31.249,31.463H6.75A2.745,2.745,0,0,1,5.1,26.52l1.235-.925a2.236,2.236,0,0,0,.87-1.432l1.55-9.394a10.368,10.368,0,0,1,20.49.008l1.549,9.386a2.236,2.236,0,0,0,.87,1.432l1.236.925a2.745,2.745,0,0,1-1.65,4.943ZM19,7.5A8.814,8.814,0,0,0,10.237,15l-1.551,9.4a3.728,3.728,0,0,1-1.45,2.387L6,27.718a1.248,1.248,0,0,0,.75,2.247h24.5A1.248,1.248,0,0,0,32,27.719l-1.236-.926a3.728,3.728,0,0,1-1.45-2.387l-1.55-9.394A8.815,8.815,0,0,0,19,7.5Z",
    transform: "translate(-4 -2.985)",
    fill: "#2b2b2b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_565",
    "data-name": "Trac\\xE9 565",
    d: "M25.276,6.794a.754.754,0,0,1-.754-.754V5.015a1.507,1.507,0,1,0-3.015,0V6.04A.754.754,0,0,1,20,6.04V5.015a3.015,3.015,0,0,1,6.03,0V6.04A.754.754,0,0,1,25.276,6.794Z",
    transform: "translate(-8.015 -2)",
    fill: "#2b2b2b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_566",
    "data-name": "Trac\\xE9 566",
    d: "M22.276,44.03A5.282,5.282,0,0,1,17,38.754a.754.754,0,0,1,1.507,0,3.769,3.769,0,0,0,7.537,0,.754.754,0,0,1,1.507,0A5.282,5.282,0,0,1,22.276,44.03Z",
    transform: "translate(-7.276 -11.03)",
    fill: "#2b2b2b"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNotificationModal);
export default __webpack_public_path__ + "static/media/ico_notification_modal.cce97ced453fd3322b74fa2fdab1a8dc.svg";
export { ForwardRef as ReactComponent };